import type * as t from "~/types";

export type Subscription = {
    provider: t.EmailMarketingProvider;
    email?: string;
    phone?: string;
    properties?: Record<string, string>;
};

const PLAYABLY_BACKEND_API_BASE_URL = "https://playably-backend.fly.dev";

function validateSubscriptions(subscriptions: Subscription[]) {
    for (const subscr of subscriptions) {
        if (subscr.email == null && subscr.phone == null) {
            return new Error("Subscription must have an email or phone");
        }
    }
}

export async function subscribeCustomer(
    subscriptions: Subscription[],
    shop: string,
) {
    const err = validateSubscriptions(subscriptions);
    if (err != null) {
        throw err;
    }

    const body = JSON.stringify({ subscriptions, shop });
    try {
        const url = new URL(
            "/email-marketing/subscribe",
            PLAYABLY_BACKEND_API_BASE_URL,
        );
        const res = await fetch(url, {
            body,
            method: "POST",
            headers: { "Content-Type": "application/json" },
        });

        if (!res.ok) {
            throw res;
        }

        console.log("[shpln-quiz] Customer subscribed successfully.");
    } catch (err) {
        let info: any;
        switch (true) {
            case err instanceof Response:
                info = {
                    body: await err.text(),
                    status: err.statusText,
                };
                break;
            default:
                info = err as Error;
        }

        console.error("[shpln-quiz] Customer subscription failed.", info);
    }
}
